import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, pipe } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { MonitoringService } from '../../utility/monitoring/monitoring.service';

/**
 * Service with http call to populate ip 
 */
@Injectable({
  providedIn: 'root'
})
export class IpService {

  /**
   * Costructor service
   * @param http take http client module
   * @param monitoringService service to log and monitoring
   */
  constructor(private http: HttpClient,
    private monitoringService: MonitoringService) {
  }

  /**
   * Call service and return observable of any
   * @returns Observable<any>
   */
  getIp(): Observable<any> {
    return this.http.get<any>('https://jsonip.com/')
      .pipe(
        catchError(this.monitoringService.handleError<any>('getIp', { 'ip': '127.0.0.1' }))
      );
  }
}
